// extracted by mini-css-extract-plugin
export default {"section6":"Section6_section6__iLr02","card":"Section6_card__CSxJK","button_container":"Section6_button_container__KLbk3","cta":"Section6_cta__YhJS-"};